// extracted by mini-css-extract-plugin
module.exports = {"form":"StripePayment_styles_form__7Krc5","form-grid":"StripePayment_styles_form-grid__RVV6c"};